import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import {
    createStyles,
    Stack
} from '@mantine/core';

//import { fetchPosts } from '../actions/postsActions';
//import { Post } from '../components/Post';
import { Progress } from '@mantine/core';
import { useSelector } from 'react-redux';
import { FooterSimple } from '../components/FooterSimple';
import { MobileSimpleHeader } from '../components/MobileSimpleHeader';
import { CarComponent } from '../components/CarComponent';




import black_and_white_mercedes_benz from '../assets/black_and_white_mercedes_benz.jpg';
const useStyles = createStyles((theme) => ({
    cardAlign: {
        margin: '0 auto',
    },
    
}));

//this needs params
const AuctionItemPreview = () => {
    const { classes } = useStyles();

    return (
        <>
            <MobileSimpleHeader 
                avatar={black_and_white_mercedes_benz}
                drawSubSectMenu={false}
            />
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <Stack
                align="center"
                justify="space-around"
            >
                <CarComponent className={classes.cardAlign}/>
                <br/>
                <CarComponent />
                <br/>
                <CarComponent />
            </Stack>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <FooterSimple />
        </>
    )

}

export default AuctionItemPreview
